import React, { useState } from 'react';
import { Page } from '../../components/layout';
import {
  ContinueWithEmailForm,
  ContinueWithEmailMode,
} from '../../components/Login/ContinueWithEmailForm';
import SocialLoginButtons from '../../components/Welcome/SocialLoginButtons';
import {
  OnboardingProgressIndicator,
  OnboardingStep,
} from '../../components/OnboardingProgressIndicator/OnboardingProgressIndicator';
import {
  DefaultPageProps,
  withApolloClient,
  withAuthServerSideProps,
} from '../../services/authMiddleware';
import { LinkWrapper } from '../../components/LinkWrapper/LinkWrapper';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import TRANSLATION_FILES from '../../public/locales/constants';
import { getUserQuery } from '../../graphql/queries';
import { useQuery } from '@apollo/client';

type RegisterPageProps = {
  userNotAuthed?: boolean;
} & DefaultPageProps;

function Register({
  userNotAuthed,
  requestCookieConsent,
  cookieConsentGiven,
}: RegisterPageProps) {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation(TRANSLATION_FILES.signInUp);

  const { data = { getUser: null } } = useQuery(getUserQuery, {
    skip: userNotAuthed,
  });
  const user = data.getUser;

  return (
    <Page title="Vytal - Konto anlegen" user={user}>
      <OnboardingProgressIndicator
        onboardingStep={OnboardingStep.RegisterAccount}
      />
      <h2 className="headline">{t('createAccount')}</h2>
      <div className="mb-8">
        {t('createAccount')}
        &nbsp;
        <LinkWrapper href="/welcome/login">
          <a>{t('login')}</a>
        </LinkWrapper>
      </div>
      <div className="flex flex-col">
        <ContinueWithEmailForm
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          loginMode={ContinueWithEmailMode.REGISTER}
        />
        <div className="mb-5" />
        <SocialLoginButtons
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          requestCookieConsent={requestCookieConsent}
          cookieConsentGiven={cookieConsentGiven}
        />
      </div>
    </Page>
  );
}

export default withApolloClient(Register);

export const getServerSideProps = withAuthServerSideProps(
  async (authContext, locale) => {
    const translations = await serverSideTranslations(locale || 'en', [
      TRANSLATION_FILES.signInUp,
      TRANSLATION_FILES.common,
      TRANSLATION_FILES.leftScreen,
      TRANSLATION_FILES.vytalBowls,
    ]);
    return {
      props: {
        ...translations,
      },
    };
  },
  { requireAuth: false },
);
